import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bem-vindo de volta!");
      if (u?.role === "agency_admin") navigate("/imobiliaria");
      else if (u?.role === "admin") navigate("/admin");
      else navigate("/app");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao entrar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-[#FAFAF8]">
      <div className="flex-1 flex items-center justify-center px-5 py-10">
        <div className="w-full max-w-sm">
          <Link to="/" className="font-heading text-2xl font-extrabold text-[#1B3A2F] block mb-8">
            estatebroker<span className="text-[#3B9EFF]">.AI</span>
          </Link>
          <h1 className="font-heading text-3xl font-bold text-[#1C1C19]">Bom te ver de volta.</h1>
          <p className="text-stone-500 mt-2">Entra pra trabalhar sua carteira.</p>

          <form onSubmit={handleSubmit} className="mt-8 space-y-4">
            <div>
              <Label htmlFor="email">E-mail</Label>
              <Input
                id="email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                className="mt-1.5"
                placeholder="seu@email.com"
              />
            </div>
            <div>
              <Label htmlFor="password">Senha</Label>
              <Input
                id="password" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                className="mt-1.5"
                placeholder="••••••••"
              />
            </div>
            <Button
              type="submit" disabled={loading}
              data-testid="login-submit-btn"
              className="w-full bg-[#1B3A2F] hover:bg-[#244A3C] text-white py-6 rounded-lg"
            >
              {loading ? "Entrando..." : "Entrar"}
            </Button>
          </form>

          <p className="mt-6 text-sm text-stone-500 text-center">
            Ainda não tem conta?{" "}
            <Link to="/auth/register" data-testid="goto-register-link" className="text-[#1B3A2F] font-semibold hover:underline">
              Criar agora
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
